export const MODEL_TRADE_FREQUENCY_ORDER = ['monthly', 'quarterly', 'semi-annually', 'annually'];
